module.exports = __webpack_public_path__ + "static/media/snx.634658ed.svg";